<template>
  <div class="container lms-wrapper">
    
    <student-nav />

    <div class="lms-content" @click="closeLevel2()">
      <student-header :navbarmode.sync="navbarMode" ref="lmsv4header" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class=""
        style="height: calc(100vh - 80px);"
        
      >
        <div class="container-fluid mg-b-20" v-if="homeDataRdy">
          <part-rank v-if="$store.state.app.activeGroup.id!=9358" :mustJoinCourses="mustJoinCourses"></part-rank>
          <div v-if="$store.state.app.activeGroup.id == 9157" class="row">
            

            <div
            class="col-12"
            v-for="(t, i) in homeTypes.filter(x=>x.code=='academy.monicpa')"
            :key="`homeTypes_${i}`"
          >
            <div class="card go-step-6" style="border-radius: 20px;">
              <div class="d-flex align-items-center justify-content-between">
                <ul class="nav nav-line wd-100p bg-light d-none">
                  
                  <li class="nav-item pos-relative mg-x-20-f">
                    <a
                      @click="t.activeTab = 1"
                      class="nav-link"
                      :class="{ active: t.activeTab == 1 }"
                      role="button"
                      >Элссэн</a
                    >
                    <span class="pos-absolute t-5 r--20 badge badge-light">{{
                      t.joinedCount
                    }}</span>
                  </li>
                  <li class="nav-item pos-relative">
                    <a
                      @click="t.activeTab = 0"
                      class="nav-link"
                      :class="{ active: t.activeTab == 0 }"
                      role="button"
                      >Элсээгүй</a
                    >
                    <span class="pos-absolute t-5 r--20 badge badge-light">{{
                      t.notJoinedCount
                    }}</span>
                  </li>
                  <li class="nav-item mg-r-20-f" style="margin-left: auto">
                    <router-link
                      class="nav-link"
                      :to="{
                        name: 'lmsCourses',
                        params: {
                          md: t.activeTab == 1 ? 3 : 1,
                          cnm: 'null',
                          type: t.id,
                          d1: 'null',
                          d2: 'null',
                        },
                      }"
                    >
                      Бүгдийг үзэх ({{
                        t.activeTab == 1 ? t.joinedCount : t.notJoinedCount
                      }})
                    </router-link>
                  </li>
                </ul>
              </div>

              <div class="card-body" style="background-image: linear-gradient(135deg, #00a995, #002e5b); border-radius: 20px;">
                <div class="bg-white pos-absolute b-0 r-0" style="border-radius: 20px 0 20px 0;">
                  <router-link
                      class="nav-link"
                      :to="{
                        name: 'lmsCourses',
                        params: {
                          md: t.activeTab == 1 ? 3 : 1,
                          cnm: 'null',
                          type: t.id,
                          d1: 'null',
                          d2: 'null',
                        },
                      }"
                    >
                      Бүх сургалтууд >
                    </router-link>
                </div>
                <div class="d-flex align-items-center">
                  <img src="https://res.gosmart.mn/media/logo/monicpa-academy.png?w=200" />
                  <div style="font-size: 32px; font-weight: 500; font-style: italic;  letter-spacing: 2px;" class="ml-auto text-white text-uppercase text-italic">Your CPD partner</div>
                </div>
                <div class="row">
                  <div
                    v-for="(c, cri) in t.activeTab == 0
                      ? t.notJoined
                      : t.joined"
                    :key="`c_${cri}`"
                    class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
                  >
                    <div class="card" style="border-radius: 20px;">
                      <!-- <router-link :to="t.activeTab==1?({name: 'lmsCourseView',  params: {  id: c.id, bid: 0, iid: 0, bot: 0 }}):({ name: 'lmsAttend',  params: {  id: c.id, s1: 0, s2: 0 }})"> -->
                      <router-link :to="{ name: 'lmsCourseView', params: { id: c.id, bid: 0, iid: 0, bot: 0 } }" role="button">
                        <img style="border-radius: 20px 20px 0 0;"
                          :src="`${c.cover}?h=120&mode=crop`"
                          class="card-img-top ht-120"
                          alt="..."
                        />
                        <div class="card-body">
                          <p
                            class="card-text"
                            v-if="c.option.timeCalculationMethod == 9"
                          >
                            Хугацаа:
                            <span class="font-weight-bold">{{ c.days }}</span>
                            <sup>хоног</sup>
                          </p>
                          <p class="card-text" v-else>
                            {{ c.startDate | moment("YYYY/MM/DD") }}
                          </p>
                          <h6 class="card-title text-rows-3" :title="c.name">
                            {{ c.name }}
                          </h6>
                        </div>
                      </router-link>
                      <!-- </router-link> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>



          </div>
          <part-user v-else :mustJoinCourses="mustJoinCourses" class="d-none d-md-block"></part-user>

          <sanal-asuulga v-if="$store.state.app.activeGroup.id == 9358 
          || $store.state.app.activeGroup.id == 9256
          || $store.state.app.activeGroup.id == 9352
          " class="pt-3"></sanal-asuulga>

          <div class="row">
            <part-course-new :list="courses" class="col-sm-12 col-md-6 order-sm-2 order-md-1"></part-course-new>
            <part-course-recent :list="coursesRecent" class="col-sm-12 col-md-6 order-sm-1 order-md-2"></part-course-recent>
          </div>
        
        <!-- <div class="lms-content-body"> -->
        <div class="row" v-if="!($store.state.app.activeGroup.id == 9241 || $store.state.app.activeGroup.id == 9249)">
          <div class="col-12" v-if="myCourses.length>0">
              <div class="card go-step-5">
                <div
                  class=" card-header d-flex align-items-center justify-content-between"
                >
                  <h6 class="mg-b-0 tx-semibold">Миний сургалтууд</h6>
                  <div class="tx-13 d-flex align-items-center">
                    <router-link
                      :to="{
                        name: 'lmsCourses',
                        params: {
                          md: 3,
                          cnm: 'null',
                          type: -1,
                          d1: 'null',
                          d2: 'null',
                        },
                      }"
                      class="d-flex align-items-center link-03 lh-0"
                      role="button"
                    >
                      Бүх сургалтыг үзэх
                      <feather
                        type="chevron-right"
                        :size="16"
                        class="mg-l-5"
                      ></feather>
                    </router-link>
                  </div>
                </div>
                <div class="card-body">
                  <div v-if="$store.state.app.activeGroup.id == 9358">
                    <div v-for="(c, ci) in myCourses" :key="ci" :class="`${ myCourses.length-1>ci ? 'bd-b':''} border-dashed pd-y-5`">
                      <router-link :to="{ name: 'lmsCourseView', params: { id: c.id, bid: 0, iid: 0, bot: 0 } }">
                        {{ c.name }}
                      </router-link>
                    </div>
                  </div>
                  <div v-else class="row">
                    <div
                      v-for="(c, ci) in myCourses"
                      :key="ci"
                      class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
                    >
                      <div class="card">
                        <router-link
                        :to="{ name: 'lmsCourseView', params: { id: c.id, bid: 0, iid: 0, bot: 0 } }"
                        >
                          <img
                            :src="`${c.cover}?h=160&mode=crop`"
                            class="card-img-top ht-160"
                            alt="..."
                          />
                          <div class="card-body">
                            <!-- <p class="card-text" v-if="c.option.timeCalculationMethod==9">
                            Хугацаа:
                            <span class="font-weight-bold">{{c.days}}</span>
                            <sup>хоног</sup>
                          </p>
                          <p class="card-text" v-else>{{c.startDate | moment('YYYY/MM/DD')}}</p> -->
                            <h6
                              class="card-title mg-b-0-f text-rows-3"
                              :title="c.name"
                            >
                              {{ c.name }}
                            </h6>
                          </div>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          <div class="col-12" v-if="futureCourses.length>0">
            <div class="card go-step-6">
              <div
                class=" card-header d-flex align-items-center justify-content-between"
              >
                <h6 class="mg-b-0 tx-semibold">
                  Элссэн сургалтууд <sup> /удахгүй эхлэх/</sup>
                </h6>
                <div class="tx-13 d-flex align-items-center">
                  <router-link
                    :to="{
                      name: 'lmsCourses',
                      params: {
                        md: 1,
                        cnm: 'null',
                        type: -1,
                        d1: 'null',
                        d2: 'null',
                      },
                    }"
                    class="d-flex align-items-center link-03 lh-0"
                    role="button"
                  >
                    Бүх сургалтыг үзэх
                    <feather
                      type="chevron-right"
                      :size="16"
                      class="mg-l-5"
                    ></feather>
                  </router-link>
                </div>
              </div>
              <div class="card-body">
                <div v-if="$store.state.app.activeGroup.id == 9358">
                  <div v-for="(c, ci) in futureCourses" :key="ci" :class="`${ futureCourses.length-1>ci ? 'bd-b':''} border-dashed pd-y-5`">
                    <router-link :to="{ name: 'lmsCourseView', params: { id: c.id, bid: 0, iid: 0, bot: 0 } }">
                      {{ c.name }}
                    </router-link>
                  </div>
                </div>
                <div v-else class="row">
                  <div
                    v-for="(c, ci) in futureCourses"
                    :key="ci"
                    class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
                  >
                    <router-link
                      class="card"
                      :to="{ name: 'lmsCourseView', params: { id: c.id, bid: 0, iid: 0, bot: 0 } }"
                      role="button"
                    >
                      <img
                        :src="`${c.cover}?h=160&mode=crop`"
                        class="card-img-top ht-160"
                        alt="..."
                      />
                      <div class="card-body">
                        <p
                          class="card-text"
                          v-if="c.option.timeCalculationMethod == 9"
                        >
                          Хугацаа:
                          <span class="font-weight-bold">{{ c.days }}</span>
                          <sup>хоног</sup>
                        </p>
                        <p class="card-text" v-else>
                          {{ c.startDate | moment("YYYY/MM/DD") }}
                        </p>
                        <h6 class="card-title text-rows-3" :title="c.name">
                          {{ c.name }}
                        </h6>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12" v-if="courses.length>0">
            <div class="card go-step-6">
              <div
                class=" card-header d-flex align-items-center justify-content-between"
              >
                <h6 class="mg-b-0 tx-semibold">Элсээгүй сургалтууд</h6>
                <div class="tx-13 d-flex align-items-center">
                  <router-link
                    :to="{
                      name: 'lmsCourses',
                      params: {
                        md: 1,
                        cnm: 'null',
                        type: -1,
                        d1: 'null',
                        d2: 'null',
                      },
                    }"
                    class="d-flex align-items-center link-03 lh-0"
                    role="button"
                  >
                    Бүх сургалтыг үзэх
                    <feather
                      type="chevron-right"
                      :size="16"
                      class="mg-l-5"
                    ></feather>
                  </router-link>
                </div>
              </div>
              <div class="card-body">
                <div v-if="$store.state.app.activeGroup.id == 9358">
                  <div v-for="(c, ci) in courses" :key="ci" :class="`${ courses.length-1>ci ? 'bd-b':''} border-dashed pd-y-5`">
                    <router-link :to="{ name: 'lmsCourseView', params: { id: c.id, bid: 0, iid: 0, bot: 0 } }">
                      {{ c.name }}
                    </router-link>
                  </div>
                </div>
                <div v-else class="row">
                  <div
                    v-for="(c, ci) in courses"
                    :key="ci"
                    class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
                  >
                    <div class="card">
                      <router-link
                      :to="{ name: 'lmsCourseView', params: { id: c.id, bid: 0, iid: 0, bot: 0 } }"
                      >
                        <img
                          :src="`${c.cover}?h=160&mode=crop`"
                          class="card-img-top ht-160"
                          alt="..."
                        />
                        <div class="card-body">
                          <p
                            class="card-text"
                            v-if="c.option.timeCalculationMethod == 9"
                          >
                            Хугацаа:
                            <span class="font-weight-bold">{{ c.days }}</span>
                            <sup>хоног</sup>
                          </p>
                          <p class="card-text" v-else>
                            {{ c.startDate | moment("YYYY/MM/DD") }}
                          </p>
                          <h6 class="card-title text-rows-3" :title="c.name">
                            {{ c.name }}
                          </h6>
                        </div>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div
            class="col-12"
            v-for="(t, i) in homeTypes.filter(x=>x.code!='academy.monicpa')"
            :key="`homeTypes_${i}`"
          >
            <div class="card go-step-6">
              <div class="d-flex align-items-center justify-content-between">
                <!-- <h6 class="mg-b-0">{{c.name}}</h6> -->
                <ul class="nav nav-line wd-100p bg-light">
                  <li class="nav-item mg-x-20">
                    <a
                      class=" nav-link mg-b-0-f tx-14 text-uppercase pd-b-5-f pd-t-10-f"
                      style="color: #001737; font-weight: 500"
                      >{{ t.name }}</a
                    >
                  </li>
                  <li class="nav-item pos-relative mg-x-20-f">
                    <a
                      @click="t.activeTab = 1"
                      class="nav-link"
                      :class="{ active: t.activeTab == 1 }"
                      role="button"
                      >Элссэн</a
                    >
                    <span class="pos-absolute t-5 r--20 badge badge-light">{{
                      t.joinedCount
                    }}</span>
                  </li>
                  <li class="nav-item pos-relative">
                    <a
                      @click="t.activeTab = 0"
                      class="nav-link"
                      :class="{ active: t.activeTab == 0 }"
                      role="button"
                      >Элсээгүй</a
                    >
                    <span class="pos-absolute t-5 r--20 badge badge-light">{{
                      t.notJoinedCount
                    }}</span>
                  </li>
                  <li class="nav-item mg-r-20-f" style="margin-left: auto">
                    <router-link
                      class="nav-link"
                      :to="{
                        name: 'lmsCourses',
                        params: {
                          md: t.activeTab == 1 ? 3 : 1,
                          cnm: 'null',
                          type: t.id,
                          d1: 'null',
                          d2: 'null',
                        },
                      }"
                    >
                      <!-- Бүх {{t.activeTab==1?'элссэн':'элсээгүй'}} -->
                      <!-- <span class="text-lowercase">{{t.name}}</span> -->
                      Бүгдийг үзэх ({{
                        t.activeTab == 1 ? t.joinedCount : t.notJoinedCount
                      }})
                    </router-link>
                  </li>
                </ul>
              </div>

              <div class="card-body">
                <div class="row">
                  <div
                    v-for="(c, cri) in t.activeTab == 0
                      ? t.notJoined
                      : t.joined"
                    :key="`c_${cri}`"
                    class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
                  >
                    <div class="card">
                      <!-- <router-link :to="t.activeTab==1?({name: 'lmsCourseView',  params: {  id: c.id, bid: 0, iid: 0, bot: 0 }}):({ name: 'lmsAttend',  params: {  id: c.id, s1: 0, s2: 0 }})"> -->
                      <router-link :to="{ name: 'lmsCourseView', params: { id: c.id, bid: 0, iid: 0, bot: 0 } }" role="button">
                        <img
                          :src="`${c.cover}?h=160&mode=crop`"
                          class="card-img-top ht-160"
                          alt="..."
                        />
                        <div class="card-body">
                          <p
                            class="card-text"
                            v-if="c.option.timeCalculationMethod == 9"
                          >
                            Хугацаа:
                            <span class="font-weight-bold">{{ c.days }}</span>
                            <sup>хоног</sup>
                          </p>
                          <p class="card-text" v-else>
                            {{ c.startDate | moment("YYYY/MM/DD") }}
                          </p>
                          <h6 class="card-title text-rows-3" :title="c.name">
                            {{ c.name }}
                          </h6>
                        </div>
                      </router-link>
                      <!-- </router-link> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          
        <div class="row d-none">
          <div
            v-for="(s, si) in stats"
            :key="si"
            :class="
              stats.length == 4
                ? `col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3`
                : `col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4`
            "
          >
            <div class="card">
              <div class="card-body pd-y-15">
                <router-link to="/lms/courses/4/null/-1/null/null">
                  <div class="media">
                    <div
                      :class="`wd-40 wd-md-50 ht-40 ht-md-50 bg-${s.bg} tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-6`"
                      style="min-width: 40px"
                    >
                      <feather :type="s.icon" class="wd-30-f ht-30-f"></feather>
                    </div>
                    <div class="media-body">
                      <h6
                        class=" tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8"
                      >
                        {{ s.title }}
                      </h6>
                      <h5
                        class=" tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0"
                      >
                        {{ s.value }}
                      </h5>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <template
            v-if="
              $store.state.app.activeGroup.id == 9254 ||
              $store.state.app.activeGroup.id == 9272 ||
              $store.state.app.activeGroup.id == 9282 ||
              $store.state.app.activeGroup.id == 9358 ||
              $store.state.app.activeGroup.id == 9256 ||
              $store.state.app.activeGroup.id == 9352
            "
          >
            <div
              v-if="$store.state.app.isMobile"
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            >
              <div class="card">
                <sanal-asuulga class="px-3 pt-3"></sanal-asuulga>
              </div>
            </div>
            

            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <div class="card">
                <div class="card">
                  <img
                    v-if="
                      $store.state.app.activeGroup.id == 9241 ||
                      $store.state.app.activeGroup.id == 9249
                    "
                    src="assets/img/golomt/temp-course-cover2.png"
                    class="card-img-top"
                    alt="..."
                  />
                  <img
                    v-else
                    src="assets/img/must.jpg"
                    class="card-img-top"
                    alt="..."
                  />
                  <div class="card-body">
                    <router-link
                      class="card-title"
                      role="button"
                      :to="{
                        name: 'lmsCourses',
                        params: {
                          md: 2,
                          cnm: 'null',
                          type: -1,
                          d1: 'null',
                          d2: 'null',
                        },
                      }"
                    >
                      <h5>Заавал хамрагдах сургалт</h5>

                      <div class="progress ht-10 op-7 mg-b-5">
                        <div
                          class="progress-bar bg-success"
                          :style="`width: ${(
                            (mustJoinCourses.finished * 100) /
                            mustJoinCourses.all
                          ).toFixed(2)}%`"
                          role="progressbar"
                        ></div>
                      </div>
                    </router-link>
                    <div class="d-flex justify-content-between tx-12">
                      <span class="tx-color-03"
                        >{{ mustJoinCourses.finished }}/{{
                          mustJoinCourses.all
                        }}
                        биелүүлсэн</span
                      >
                      <strong class="tx-medium"
                        >{{
                          (
                            (mustJoinCourses.finished * 100) /
                            mustJoinCourses.all
                          ).toFixed(2)
                        }}%</strong
                      >
                    </div>
                  </div>
                  <router-link
                    :to="{
                      name: 'lmsCourses',
                      params: {
                        md: 2,
                        cnm: 'null',
                        type: -1,
                        d1: 'null',
                        d2: 'null',
                      },
                    }"
                    type="button"
                    :class="`btn btn-xs rounded-pill pos-absolute r-10 t-15 btn-${
                      $store.state.app.skin.dark ? 'dark' : 'white'
                    }`"
                    >Бүх сургалт</router-link
                  >
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <div class="card">
                <div class="card-header pd-b-0 pd-x-20 bd-b-0 go-step-4">
                  <h5 class="mg-b-0">Хамгийн сүүлд үзсэн сургалт</h5>
                </div>
                <div class="card-body pd-x-15 pd-y-10">
                  <router-link
                    :to="{
                      name: 'lmsCourseView',
                      params: { id: r.id, bid: 0, iid: 0, bot: 0 },
                    }"
                    role="button"
                    v-for="(r, ri) in coursesRecent"
                    :key="ri"
                    class="media pd-x-15 pd-y-10 mg-t-5 bg-opacity-dark-05"
                  >
                    <div class="media-body">
                      <div class="d-flex justify-content-between">
                        <h6 class="tx-13 mg-b-2">{{ r.name }}</h6>
                        <div class="tx-13 d-flex align-items-center">
                          <span class="tx-color-03 tx-10">{{
                            r.myShare.lastViewDate | moment("from")
                          }}</span>
                        </div>
                      </div>

                      <div class="d-flex justify-content-between tx-12 mg-t-5">
                        <b-progress
                          :value="`${r.myShare.percent.toFixed(2)}`"
                          class="wd-80p mg-t-7 ht-5"
                        ></b-progress>
                        <strong class="tx-medium tx-13"
                          >{{ r.myShare.percent.toFixed(2) }}%</strong
                        >
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div
              v-if="$store.state.app.isMobile"
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            >
              <div class="card">
                <sanal-asuulga class="px-3 pt-3"></sanal-asuulga>
              </div>
            </div>
            <template v-if="$store.state.app.activeGroup.id == 9157">
              <!-- Monicpa setguulee nuur huudsand gardag bolgoy ged hiiv -->
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div class="card">
                  <div
                    class=" card-header d-flex align-items-center justify-content-between"
                  >
                    <h6 class="mg-b-0">Сонин сэтгүүл</h6>
                    <div class="tx-13 d-flex align-items-center">
                      <router-link
                        to="/lms/magazineList/0"
                        class="d-flex align-items-center link-03 lh-0"
                        role="button"
                      >
                        Бүгдийг үзэх
                        <feather
                          type="chevron-right"
                          :size="16"
                          class="mg-l-5"
                        ></feather>
                      </router-link>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div
                        v-for="(c, ci) in magazines"
                        :key="ci"
                        class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"
                      >
                        <div class="card" @click="gotoMagazine(c.id)">
                          <router-link
                            to="/lms/magazineList/0"
                          >
                            <img
                              :src="`${c.secondAttachmentUrl}?h=480&mode=crop`"
                              class="card-img-top"
                              :alt="c.task"
                            />
                            <div class="card-body">
                              <h6
                                class="card-title mg-b-0-f text-rows-3"
                                :title="c.task"
                              >
                                {{ c.task }}
                              </h6>
                            </div>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div v-else class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <div class="card">
                <div class="card">
                  <img
                    v-if="
                      $store.state.app.activeGroup.id == 9241 ||
                      $store.state.app.activeGroup.id == 9249
                    "
                    src="assets/img/golomt/temp-course-cover2.png"
                    class="card-img-top"
                    alt="..."
                  />
                  <img
                    v-else
                    src="assets/img/must.jpg"
                    class="card-img-top"
                    alt="..."
                  />
                  <div class="card-body">
                    <router-link
                      class="card-title"
                      role="button"
                      :to="{
                        name: 'lmsCourses',
                        params: {
                          md: 2,
                          cnm: 'null',
                          type: -1,
                          d1: 'null',
                          d2: 'null',
                        },
                      }"
                    >
                      <h5>Заавал хамрагдах сургалт</h5>

                      <div class="progress ht-10 op-7 mg-b-5">
                        <div
                          class="progress-bar bg-success"
                          :style="`width: ${(
                            (mustJoinCourses.finished * 100) /
                            mustJoinCourses.all
                          ).toFixed(2)}%`"
                          role="progressbar"
                        ></div>
                      </div>
                    </router-link>
                    <div class="d-flex justify-content-between tx-12">
                      <span class="tx-color-03"
                        >{{ mustJoinCourses.finished }}/{{
                          mustJoinCourses.all
                        }}
                        биелүүлсэн</span
                      >
                      <strong class="tx-medium"
                        >{{
                          (
                            (mustJoinCourses.finished * 100) /
                            mustJoinCourses.all
                          ).toFixed(2)
                        }}%</strong
                      >
                    </div>
                  </div>
                  <router-link
                    :to="{
                      name: 'lmsCourses',
                      params: {
                        md: 2,
                        cnm: 'null',
                        type: -1,
                        d1: 'null',
                        d2: 'null',
                      },
                    }"
                    type="button"
                    :class="`btn btn-xs rounded-pill pos-absolute r-10 t-15 btn-${
                      $store.state.app.skin.dark ? 'dark' : 'white'
                    }`"
                    >Бүх сургалт</router-link
                  >
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <div class="card">
                <div class="card-header pd-b-0 pd-x-20 bd-b-0 go-step-4">
                  <h5 class="mg-b-0">Хамгийн сүүлд үзсэн сургалт</h5>
                </div>
                <div class="card-body pd-x-15 pd-y-10">
                  <router-link
                    :to="{
                      name: 'lmsCourseView',
                      params: { id: r.id, bid: 0, iid: 0, bot: 0 },
                    }"
                    role="button"
                    v-for="(r, ri) in coursesRecent"
                    :key="ri"
                    class="media pd-x-15 pd-y-10 mg-t-5 bg-opacity-dark-05"
                  >
                    <div class="media-body">
                      <div class="d-flex justify-content-between">
                        <h6 class="tx-13 mg-b-2">{{ r.name }}</h6>
                        <div class="tx-13 d-flex align-items-center">
                          <span class="tx-color-03 tx-10">{{
                            r.myShare.lastViewDate | moment("from")
                          }}</span>
                        </div>
                      </div>

                      <div class="d-flex justify-content-between tx-12 mg-t-5">
                        <b-progress
                          :value="`${r.myShare.percent.toFixed(2)}`"
                          class="wd-80p mg-t-7 ht-5"
                        ></b-progress>
                        <strong class="tx-medium tx-13"
                          >{{ r.myShare.percent.toFixed(2) }}%</strong
                        >
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="card go-step-5">
                <div
                  class=" card-header d-flex align-items-center justify-content-between"
                >
                  <h6 class="mg-b-0">Миний сургалтууд</h6>
                  <div class="tx-13 d-flex align-items-center">
                    <router-link
                      :to="{
                        name: 'lmsCourses',
                        params: {
                          md: 3,
                          cnm: 'null',
                          type: -1,
                          d1: 'null',
                          d2: 'null',
                        },
                      }"
                      class="d-flex align-items-center link-03 lh-0"
                      role="button"
                    >
                      Бүх сургалтыг үзэх
                      <feather
                        type="chevron-right"
                        :size="16"
                        class="mg-l-5"
                      ></feather>
                    </router-link>
                  </div>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div
                      v-for="(c, ci) in myCourses"
                      :key="ci"
                      class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
                    >
                      <div class="card">
                        <router-link
                          :to="{
                            name: 'lmsCourseView',
                            params: { id: c.id, bid: 0, iid: 0, bot: 0 },
                          }"
                        >
                          <img
                            :src="`${c.cover}?h=160&mode=crop`"
                            class="card-img-top ht-160"
                            alt="..."
                          />
                          <div class="card-body">
                            <p
                              class="card-text"
                              v-if="c.option.timeCalculationMethod == 9"
                            >
                              Хугацаа:
                              <span class="font-weight-bold">{{ c.days }}</span>
                              <sup>хоног</sup>
                            </p>
                            <p class="card-text" v-else>
                              {{ c.startDate | moment("YYYY/MM/DD") }}
                            </p>
                            <h6
                              class="card-title mg-b-0-f text-rows-3"
                              :title="c.name"
                            >
                              {{ c.name }}
                            </h6>
                          </div>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          

          
        </div>
      </div>

        <!-- </div> -->
      </vue-custom-scrollbar>
    </div>

      <vue-custom-scrollbar
        class="lms-sidebar-right"
      >
        <div class="lms-sidebar-right-header">
          <div class="pos-absolute r-20 t-20">
            




            <div :class="`dropdown dropdown-profile`" v-show="$route.name=='lmsParticipant'">
                <a href class="dropdown-link" data-toggle="dropdown">
                  <img :src="`${myResBaseUrl}v4-assets/icon1.png`" />
                </a>
                <div class="divide-y dropdown-menu dropdown-menu-right tx-13">
                  <!-- <router-link to="/user/settings/2" class="dropdown-item pd-l-0-f mg-b-15" role="button">
                    <feather type="settings" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Тохиргоо
                  </router-link> -->
                  <router-link to="/lms/profile" class="dropdown-item pd-l-0-f mg-b-15" role="button">
                    <feather type="user" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Профайл
                  </router-link>
                  <a @click="logout" class="dropdown-item pd-l-0-f mg-t-0-f" role="button">
                    <feather type="log-out" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Гарах
                  </a>
                </div>
              </div>





          </div>
          <!-- <div v-if="isDropdownOpen" class="bg-white mg-y-40 rounded-10">
            <ul class="list-group rounded-10">
              <li class="list-group-item" role="button" @click="goToProfile">
                <a role="button">Профайл</a>
              </li>
              <li class="list-group-item" role="button" @click="goToProfilee">
                <a role="button">Мэдээлэл шинэчлэх</a>
              </li>
              <li class="bg-gray-300 list-group-item" role="button" @click="goToProfileD">
                <a role="button">Буцах</a>
              </li>
            </ul>
          </div> -->
          <!-- role="button" @click="goToProfileD()" -->
          <a >
            <part-user-sidebar :mustJoinCourses="mustJoinCourses"></part-user-sidebar>
          </a>
          <!--  -->
          <!-- <user-cover /> -->
          <!-- <sanal-asuulga></sanal-asuulga>
          
           -->
           
           <template v-if="learnExamRegistration == 1">
            
            <exam-registration-egazar v-if="$store.state.app.activeGroup.id === 9379" />
            <exam-registration v-else />
           </template>
        </div>
        
        <div class="lms-sidebar-right-body">
          <!-- <div class="divide-y divide-gray-900 divide">
              <div>1</div>
              <div>2</div>
            </div> -->
          <div class="bg-light rounded-20 pd-10 mg-b-20">
            
            <div class="">
              <div class="pb-3" alt="Дуусгаагүй сургалт" title="Дуусгаагүй сургалт">

                
              <router-link class="link-01"
                  :to="{name: 'lmsCourses',
                params: { md: 3, cnm: 'null', type: -1, d1: 'null', d2: 'null' }
              }">
                    <div class="d-flex">
                      <div class="pd-r-10">
                        <div class="bg-white rounded-circle wd-40 ht-40 d-flex align-items-center justify-content-center">
                          <img :src="`${myResBaseUrl}v4-assets/svgicon/education/outline/fountain pen.svg`" />
                        </div>
                      </div>
                      <div class="pd-r-5" style="overflow: hidden">
                        <div class="font-weight-bold">{{studentHomeDataStat.notFinishedCount}}</div>
                        <div class="text-truncate text-muted tx-10">Дуусгаагүй сургалт</div>
                      </div>
                    </div>
                  </router-link>
              </div>
              <div class="" alt="Дууссан сургалт" title="Дууссан сургалт">
                <router-link class="link-01"
                  :to="{
                    name: 'lmsCourses',
                    params: { md: 4, cnm: 'null', type: -1, d1: 'null', d2: 'null' }
                  }">
                  <div class="d-flex">
                    <div class="pd-r-10">
                      <div class="bg-white rounded-circle wd-40 ht-40 d-flex align-items-center justify-content-center">
                        <img :src="`${myResBaseUrl}v4-assets/svgicon/education/outline/students.svg`" />
                      </div>
                    </div>
                    <div class="pd-r-5" style="overflow: hidden">
                      <div class="font-weight-bold">{{studentHomeDataStat.pointCount}}</div>
                      <div class="text-truncate text-muted tx-10">Дууссан сургалт</div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <vc-calendar is-expanded title-position="left" color="red" :from-page.sync="myFromPage" :attributes="attributes" /> 
          <!-- <vc-date-picker v-model="value1" @input="vcChanged" @update:page="vcChanged"></vc-date-picker> -->

          <!-- <student-calendar /> -->
        </div>

        <div class="lms-sidebar-right-footer">
          <div @click="(showLiveSidebar= true)" role="button" style="border-color: #f6f6f6" class="d-flex align-items-center bd-t bd-1 pd-t-20" v-if="(calendarData.length>0)">
            <div class="mg-r-10 d-flex mg-l-15">
              <div v-for="c in getLiveImages(3)" :key="c.course.id" class="bg-white pd-5 rounded-circle" style="margin-left: -15px">
                <img v-if="c.course!=null && c.course.cover!=undefined" :src="`${c.course.cover}`" class="rounded-circle wd-35 ht-35" />
              </div>
            </div>
            <div>
              <div class="text-muted tx-12">Одоогоор {{calendarData.length}} сургалт</div>
              <div class="tx-14 font-weight-bold d-flex align-items-center">
                <div class="bg-danger ht-10 wd-10 rounded-circle mg-r-10"></div>
                Live үзэх
              </div>
            </div>
          </div>
        </div>
      </vue-custom-scrollbar>
    </div>

    <div>
      <b-modal
        v-model="joinData.modal"
        :title="joinData.mode == -22 ? joinData.obj.name : 'Сургалтад элсэх'"
        hide-footer
        size="lg"
        scrollable
        :fullscreen="joinData.mode == -22"
      >
        <div v-if="joinData.mode == -22">
          <!-- <a @ v-for="(d,di) in joinData.cdiscs" :key="di">{{d.task}}</a> -->
          <!-- <forum-topic :task="d" v-for="(d,di) in joinData.cdiscs" :key="di" /> -->
          <course-discussions
            :discussions="joinData.cdiscs"
          ></course-discussions>
        </div>

        <div
          v-if="joinData.mode == -22"
          class="mg-b-20"
          v-html="joinData.cinfo"
        ></div>
        <h6 v-else class="mg-b-20">{{ joinData.obj.name }}</h6>
        <div class="row" v-if="joinData.mode != -22">
          <div
            v-for="(c, ii) in joinData.infos"
            :key="ii"
            class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
          >
            <div class="card">
              <div class="card-body bd">
                <div class="media">
                  <div class="mg-r-20">
                    <feather :type="c.icon"></feather>
                  </div>
                  <div class="media-body">
                    <h6
                      class=" tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8"
                    >
                      {{ c.title }}
                    </h6>
                    <h6 class="tx-13 tx-normal mg-b-0">{{ c.value }}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="joinData.mode != -22" class="text-center wd-100p">
          <a
            @click="directJoinToCourse(joinData.obj)"
            role="button"
            class="btn btn-sm pd-x-15 btn-primary btn-uppercase"
            >Элсэх</a
          >
        </div>
      </b-modal>

      <!-- <v-tour
        name="myTour"
        :steps="steps"
        :options="myOptions"
        :callbacks="myCallbacks"
      ></v-tour>
      <button
        v-show="tourStartBtnShow && !$store.state.app.isMobile"
        @click="tourStart()"
        class="pos-fixed b-20 r-20 text-uppercase btn btn-light btn-xs"
      >
        Хөтөч ашиглах ?
      </button> -->

      
    </div>



    <b-sidebar v-model="showLiveSidebar" backdrop right width="500px">
      <div class="pd-20 card card-widget card-events bd-0">
        <ul class="list-unstyled media-list mg-b-0">
          <li
            @click="cal.hasLink ? $router.push(getRoute(cal)) : ''"
            class="media mg-b-20"
            v-for="(cal, i) in calendarData"
            :key="i"
            role="button"
          >
            <!-- {{cal}} -->
            <div class="text-center media-left">
              <div>
                <!-- <feather
                  v-else-if="cal.type==1"
                  type="pen-tool"
                  class="tx-color-03 wd-25-f ht-25-f"
                ></feather> -->
                <!-- <feather v-if="cal.type==3" type="wifi" class="text-danger wd-25-f ht-25-f"></feather> -->
                <img
                  v-if="cal.type == 3"
                  src="https://res.gosmart.mn/media/gif/live.gif"
                  class="wd-40"
                />
                <img
                  v-else-if="cal.type == 1"
                  src="https://res.gosmart.mn/media/gif/live.gif"
                  class="wd-40"
                />
                <feather
                  v-else-if="cal.type == 4"
                  type="credit-card"
                  class="tx-color-03 wd-25-f ht-25-f"
                ></feather>
                <feather
                  v-else
                  type="calendar"
                  class="tx-color-03 wd-25-f ht-25-f"
                ></feather>
              </div>
              <!-- <label>{{cal.calendarDate | moment('dddd')}}</label> -->
              <label>{{ cal.calendarDate | moment("MM/DD") }}</label>
              <p style="min-width: 45px; font-size: 16px !important">
                {{ cal.calendarDate | moment("HH:mm") }}
              </p>
              <!-- <div class="mg-t-5">{{cal.calendarDate | moment('MM/DD')}}</div> -->
            </div>
            <div class="media-body event-panel-green">
              <span
                v-if="cal.type == 1 || cal.type == 2 || cal.type == 3"
                class="event-time"
                >{{ cal.course.name }}</span
              >
              <span v-else class="event-time">{{ cal.desc }}</span>
              <router-link :to="cal.hasLink ? getRoute(cal) : ''">
                <h6 v-if="cal.type == 1 || cal.type == 3" class="event-title">
                  {{ cal.task.task }}
                </h6>
                <h6 v-else-if="cal.type == 2" class="event-title">
                  {{ cal.form.name }}
                </h6>
                <h6 v-else class="event-title">{{ cal.title }}</h6>
              </router-link>
            </div>
          </li>
        </ul>
      </div>
    </b-sidebar>

    <b-modal v-model="egazarMergeshil" title="Мэргэшлийн хүрээ сонгоно уу" centered hide-footer>
      <div class="row">
        <div class="col-12">
          <h5>Мэргэшлийн хүрээ</h5>
        </div>
        <div class="col-12">
          <!-- <loc-type-cascader :key="egazarMergeshilKey" v-model="egazarMergeshilObj.locTypeId15" :id="egazarMergeshilObj.locTypeId15" locTypekey="egazarMergeshilHvree" /> -->
          <depart-cascader 
            :key="egazarMergeshilKey" 
            v-model="egazarMergeshilObj.departId" 
            size="large"
            :id="egazarMergeshilObj.departId" :pid="47134" />
        </div>
      </div>
      <div class="d-flex justify-content-between mg-t-20">
        <a class="btn btn-sm btn-danger" @click="egazarMergeshil = false">Болих</a>
        <a class="btn btn-sm btn-primary" @click="saveMergeshilHvree">Хадгалах</a>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";



import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";

export default {
  components: {
    vueCustomScrollbar,
    courseDiscussions: () => ({
      component: import(
        "@/views/modules/lms/student/components/courseDiscussion.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    sanalAsuulga: () => ({
      component: import(
        "@/views/modules/lms/student/components/formSanalAsuulga"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    
    // studentHeader: () => ({
    //   component: import("@/views/modules/lms/student/components/header.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    examRegistration: () => ({
      component: import(
        "@/views/modules/lms/student/components/examRegistration"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    examRegistrationEgazar: () => ({
      component: import(
        "@/views/modules/lms/student/components/examRegistrationEgazar"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),


    //# VERSION 4
    partRank: () => ({
      component: import( "@/views/modules/lms/student/parts/rank.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUser: () => ({
      component: import( "@/views/modules/lms/student/parts/userMain.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partCourseNew: () => ({
      component: import( "@/views/modules/lms/student/parts/courseNew.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partCourseRecent: () => ({
      component: import( "@/views/modules/lms/student/parts/courseRecent.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    examRegistration: () => ({
      component: import(
        "@/views/modules/lms/student/components/examRegistration"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    departCascader: () => ({
      component: import("@/components/modules/hr/departCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
  },
  data() {
    return {
      egazarMergeshil: false,
      egazarMergeshilKey: 0,
      egazarMergeshilObj:{
        locTypeId15: null
      },
      isDropdownOpen: false,
      studentHomeDataStat:{},
      attributes: [],
      myFromPage: {
        year: null,
        month: null
      },
      showLiveSidebar: false,
      calendarData: [],
      value1: null,
      filterParams:{
        type: -1,
        name: null
      },
      homeDataRdy: false,
      myResBaseUrl: "https://res.gosmart.mn/",
      navbarMode: 0,
      stats: [],
      mustJoinCourses: {
        all: 0,
        finished: 0,
      },
      courses: [],
      coursesRecent: [],
      myCourses: [],
      futureCourses: [],
      learnExamRegistration: 0,
      myOptions: {
        labels: {
          buttonSkip: "Хөтөч алгасах",
          buttonPrevious: "Өмнөх",
          buttonNext: "Дараах",
          buttonStop: "Дуусгах",
        },
      },
      myCallbacks: {
        onSkip: this.myCustomSkip,
        onFinish: this.myCustomFinish,
      },
      steps: [
        {
          target: "#v-step-0",
          header: { title: "Тавтай морилно уу" },
          content: `Үндсэн цэс хэсгээс сургалтыг төрөл болон төлвөөр ангилан харах, ном контент гэх мэт бусад модулиудыг үзэх боломжтой.`,
          params: { placement: "right" },
        },
        {
          target: ".go-step-2",
          header: { title: "Анкет" },
          content:
            "Мэдээлэл шинэчлэх хэсэгт хэрэглэгчийн хувийн мэдээлэл болон зургийг оруулах боломжтой.",
          params: { placement: "bottom" },
        },
        {
          target: ".go-step-4",
          header: { title: "Хамгийн сүүлд үзсэн сургалтууд" },
          content: "Сүүлд үзсэн сургалтуудаас үргэлжлүүлэн үзэх",
          params: { placement: "left" },
        },
        {
          target: ".go-step-5",
          header: { title: "Миний сургалтууд" },
          content: "Өөрийн үзэж буй бүх сургалтыг харах",
          params: { placement: "left" },
        },
        {
          target: ".go-step-6",
          header: { title: "Элсээгүй сургалтууд" },
          content: "Элсэх боломжтой бусад сургалтыг харж, хамрагдах",
          params: { placement: "left" },
        },
        {
          target: ".go-step-7",
          header: { title: "Календарь" },
          content: `Таны хамрагдсан сургалтын шалгалт, лайв хичээл зэрэг онцлох үйл явдлуудыг харуулна.`,
          params: { placement: "top" },
        },
      ],
      tourStartBtnShow: false,

      homeTypes: [],
      joinData: {
        obj: {},
        infos: [],
        mode: null,

        cdiscs: [],
        cinfo: null,
        modal: false,
      },
      magazines: [],
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
    // this.fetchResBase();
    //Notification.success({ message: "Амжилттай", duration: 500000 });
    // Notification.warning({ message: "Амжилттай", duration: 500000, customClass: 'warning' });
    // this.$bvToast.toast("Үйлдлийг гүйцэтгэх боломжгүй", {
    //               title: "Мэдэгдэл",
    //               autoHideDelay: 500000,
    //               appendToast: false,
    //               variant: "warning",
    //               toaster: "b-toaster-bottom-left",
    //             });
    //this.toggleBodyClass("addClass", "lms-sidebar-show");
    // if (!localRead("go-help-end") && !this.$store.state.app.isMobile) {
    //   this.$tours["myTour"].start();
    // } else {
    //   this.tourStartBtnShow = true;
    // }

    //this.toggleBodyClass("addClass", "app-course");
    //require("@/assets/scss/pages/course.scss");

    // this.toggleBodyClass("addClass", "app-lms");
    //this.toggleBodyClass("addClass", "show-sidebar-right");
    //this.toggleBodyClass("removeClass", "navbar-header-fixed");
    
    
    
     //require('@/assets/css/dashforge.profile.css');
    
    //require('@/assets/scss/pages/course.scss');

    if(this.$store.state.app.activeGroup.id == 9157){
      // console.log('redirect to lmsCourses', this.$store.state.user.userInfo.locType4Code);
      if(this.$store.state.user.userInfo.locType4Code == 'register'){
        this.$router.push({name: 'lmsCourses', params: {md: 1, cnm: 'null', type: -1, d1: 'null', d2: 'null'}});
      }else{
        this.$router.push({name: 'lmsCourses', params: {md: 11, cnm: 'null', type: -1, d1: 'null', d2: 'null'}});
      }
      
    }else{
      this.init();
    }

    

    // let _obj = this.$store.state.app.mainLayoutConfig;
    // _obj.header = null;
    // _obj.expanded = true;

    //   this.handleMainLayoutConfig(_obj);

    //this.value1 = new Date();
    this.myFromPage.year= moment(new Date()).format('YYYY');
    this.myFromPage.month= moment(new Date()).format('MM');
    this.fetchCalendarData();

    if(this.$store.state.app.activeGroup.id == 9157 && this.$store.state.user.userInfo.locType4Code == 'member') {
      this.initEthicInfo();
    }

    if(this.$store.state.app.activeGroup.id == 9379) {
      this.initMergeshilHvree();
    }
  },
  destroyed() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  watch: {
    // whenever question changes, this function will run
    myFromPage: function (newQuestion, oldQuestion) {
      //console.log(newQuestion, oldQuestion);
      //this.answer = 'Waiting for you to stop typing...'
      this.fetchCalendarData();
    }
  },
  methods: {
    saveMergeshilHvree(){
      if(this.egazarMergeshilObj.departId == null){
        Notification.warning({
          title: "Мэдэгдэл",
          message: `Мэргэшлийн хүрээ сонгоно уу.`,
          duration: 5000,
          showClose: true,
          customClass: 'warning',
          position: 'bottom-right'
        });
        return;
      }
      
      // console.log('this.egazarMergeshilObj', this.egazarMergeshilObj);

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Task/PostInherited" },
        data: { model: this.egazarMergeshilObj },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          this.egazarMergeshil = false;
          Notification.success({
            title: "Амжилттай",
            message: `Мэргэшлийн хүрээ сонгогдлоо.`,
            duration: 5000,
            showClose: true,
            customClass: 'success',
            position: 'bottom-right'
          });
        }
      });
    },
    initMergeshilHvree(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      let _pid = 0;
      let prj = this.$store.state.app.groupDefaultProjects.filter((x) => x.objectTypeId == parseInt(138, 10) );
      if (prj.length > 0) _pid = prj[0].id;
      let _uid = this.$store.state.user.userInfo.profileId;;
      //console.log('_uid', _uid);
      request({
          api: { method: "GET", url: "Task/GetInherited" },
          params: {
          id: _uid,
          objectTypeId: 138,
          parentId: 0,
          projectId: _pid,
          boxId: 0,
          userId: this.$store.state.user.userInfo.userId,
          },
          store: this.$store,
      }).then((resi) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(resi!=false){
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "GET", url: "task/taskInheritedDetail" },
            params: { id: resi.data.task.id },
            store: this.$store,
          }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if(res!=false){
              this.egazarMergeshilObj = res.data.task;
              console.log('this.egazarMergeshilObj', this.egazarMergeshilObj);
              if(this.egazarMergeshilObj.departId == null){
                this.egazarMergeshil = true;
              }
              // console.log(res);
            }
          });
        }
      });
    },
    initEthicInfo(){
      request({
        api: { method: "get", url: "learn/GetMyTMZPoint" },
        store: this.$store
      }).then(res => {
        console.log(res);
        // this.point = res.data;
        if(res.data.myPointSum <100){
         Notification.warning({
          title: 'Гишүүний үүргийн биелэлт',
          message: `Та 100 оноо цуглуулхаас одоогоор ${res.data.myPointSum} оноог цуглуулсан байна. 
          Задаргааг гишүүнчлэлийн систем цэсний үүргийн биелэлт хэсгээг харах боломжтой.`,
          duration: 5000,
          showClose: true,
          customClass: 'warning',
          position: 'bottom-right'
         });
        }
      });
    },
    goToProfileD(){
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    goToProfilee(){
      this.$router.push({name: 'userProfile'});
    },
    goToProfile(){
      // console.log('goToProfile');
      this.$router.push({name: 'lmsProfile'});
    },
    getRoute(cal) {
      let rv = "";
      if (cal.type == 1) {
        ///lms/courseView/:id/:bid/:iid/:bot
        rv = `/lms/courseView/${cal.course.id}/${cal.box.id}/${cal.task.id}/${cal.box.objectTypeId}`;
      } else if (cal.type == 2) {
        rv = `/lms/courseView/${cal.course.id}/${cal.box.id}/0/${cal.box.objectTypeId}`;
      } else if (cal.type == 3) {
        rv = `/lms/courseView/${cal.course.id}/${cal.box.id}/${cal.task.id}/${cal.box.objectTypeId}`;
      } else {
        rv = cal.rawUrl;
      }
      return rv;
    },
    vcChanged(e){
      //console.log(e);
    },
    getLiveImages(n){
      if(this.calendarData.length<=n){
        return this.calendarData;
      }
      else return _.take(this.calendarData, n);
    },
    fetchCalendarData() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "get", url: "v2/Learn/GetStudentCalendarData" },
        params: {
          year: this.myFromPage.year,
          month: this.myFromPage.month,
          future: true
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('res.data.list', res.data.list);
          this.calendarData = res.data.list.filter(x=> x.type!=4 );
          // this.init();
          this.attributes= res.data.list.map(x=>{
            return{
              highlight: {
                start: { fillMode: 'solid' },
                base: { fillMode: 'light' },
                end: { fillMode: 'solid' },
              },
              popover: {
                label: `${x.title} (${moment(x.startDate).format('MM.DD HH:mm')}-${moment(x.endDate).format('HH:mm')})`,
              },
              dates: {start: x.startDate, end:x.endDate },
            }
          })
        }
      });
    },
    logout(){
      this.$refs.lmsv4header.logout();
    },
    searchHandler(){
      //console.log('srch handled');
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    gotoMagazine(id){
      localSave("magazine", id);
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    tourStart() {
      this.tourStartBtnShow = false;
      this.$tours["myTour"].start();
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
      //console.log(shown, this.navbarMode);
    },
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init() {
      request({
        api: { method: "POST", url: "v2/learn/studentHomeData" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          
          if(this.$store.state.app.activeGroup.id==9241 ||this.$store.state.app.activeGroup.id==9249){
            this.mustJoinCourses = res.data.dashboard.mustJoinCourses;
          }else{
            this.mustJoinCourses = {
              all: res.data.dashboard.stat.pointCount + res.data.dashboard.stat.notFinishedCount,
              finished: res.data.dashboard.stat.pointCount
              //finished: res.data.dashboard.stat.pointCount - res.data.dashboard.stat.notFinishedCount
            };
          }

          //console.log('v2/learn/studentHomeData', this.mustJoinCourses);
          
          this.coursesRecent = res.data.dashboard.recentCourses.list;
          this.studentHomeDataStat= res.data.dashboard.stat;
          this.initStats(res.data.dashboard.stat);
          this.myCourses = res.data.joined.courses;
          this.futureCourses = res.data.joined.futureCourses;
          this.courses = res.data.notJoined.courses;
          this.homeTypes = res.data.homeTypes.types;
          // this.mustJoinCourses=res.data.mustJoinCourses;
          // this.coursesRecent= res.data.recentCourses.list;
          // this.initStats(res.data.stat);
          this.homeDataRdy= true;
        }
      });

      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 2,
          ot: 281,
          model: {
            isPublic: true,
            locTypeId: null
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          //console.log('GetCoreList', res);
          //this.allCount = res.data.allCount;
          //this.nowDate = res.data.nowDate;
          this.magazines = res.data.tasks;
        }
      });

      // request({
      //   api: { method: "get", url: "v2/Learn/GetDashboard" },
      //   store: this.$store
      // }).then(res => {
      //   if (res != false) {
      //     //console.log(res);
      //     this.mustJoinCourses=res.data.mustJoinCourses;
      //     this.coursesRecent= res.data.recentCourses.list;
      //     this.initStats(res.data.stat);
      //   }
      // });

      // request({
      //   api: { method: "POST", url: "v2/Learn/GetHomeCourses" },
      //   data: { skip: 0, size: 3 },
      //   store: this.$store
      // }).then(res => {
      //   if (res != false) {
      //     this.courses= res.data.courses;
      //   }
      // });

      // request({
      //   api: { method: "POST", url: "v2/Learn/myJoinedCourses" },
      //   data: {
      //     skip: 0,
      //     size: 3,
      //     name: null,
      //     startDate: null,
      //     endDate: null,
      //     locTypeId: null,
      //     locTypeId1: null
      //   },
      //   store: this.$store
      // }).then(res => {
      //   if (res != false) {
      //     this.myCourses= res.data.courses;
      //   }
      // });

      let _learnExamRegistration = this.getConfigValueByKey(
        "learnExamRegistration"
      );
      if (this.$store.state.app.activeGroup.id == 6126) {
        if (this.$store.state.user.userInfo.locType4Code != "member") {
          this.learnExamRegistration = parseInt(_learnExamRegistration, 10);
        }
      } else {
        this.learnExamRegistration = parseInt(_learnExamRegistration, 10);
      }
    },
    initStats(stat) {
      //console.log('initStats', stat);
      if (
        this.$store.state.app.activeGroup.id == 9241 ||
        this.$store.state.app.activeGroup.id == 9249
      ) {
        this.stats.push({
          id: 1,
          title: "Авсан сертификат",
          value: stat.certificateCount,
          icon: "book",
          bg: "primary",
        });
        this.stats.push({
          id: 2,
          title: "Цугларсан кредит",
          value: stat.allHour,
          icon: "star",
          bg: "info",
        });
        this.stats.push({
          id: 3,
          title: "Сургалтад суусан",
          value: stat.pointCount,
          icon: "clock",
          bg: "success",
        });
        this.stats.push({
          id: 4,
          title: "Aжилчдын ранк",
          value: "0/0",
          icon: "bar-chart-2",
          bg: "danger",
        });
      } else if (
        this.$store.state.app.activeGroup.id == 1104 ||
        this.$store.state.app.activeGroup.id == 9254
        //|| this.$store.state.app.activeGroup.id == 9272
      ) {
        this.stats.push({
          id: 1,
          title: "Авсан сертификат",
          value: stat.certificateCount,
          icon: "book",
          bg: "primary",
        });
        this.stats.push({
          id: 2,
          title: "Цугларсан кредит",
          value: stat.allHour,
          icon: "star",
          bg: "info",
        });
        this.stats.push({
          id: 3,
          title: "Сургалтад суусан",
          value: stat.pointCount,
          icon: "clock",
          bg: "success",
        });
      }
    },
    myCustomSkip() {
      localSave("go-help-end", 1);
      this.tourStartBtnShow = true;
      //console.log('myCustomSkip=> ', );
    },
    myCustomFinish() {
      localSave("go-help-end", 2);
      this.tourStartBtnShow = true;
      //console.log('myCustomFinish=> ', e);
    },
    showCourseInfo(c, t) {
      //console.log('showCourseInfo=> ', c);
      //t.activeTab==1?({name: 'lmsCourseView',  params: {  id: c.id, bid: 0, iid: 0, bot: 0 }}):({ name: 'lmsAttend',  params: {  id: c.id, s1: 0, s2: 0 }})
      if (t.activeTab == -22) {
        this.joinData.infos = [];
        this.joinData.infos.push({
          id: 1,
          title: "Эхлэх огноо",
          value: moment(c.startDate).format("YYYY.MM.DD"),
          icon: "calendar",
        });
        this.joinData.infos.push({
          id: 2,
          title: "Дуусах огноо",
          value: moment(c.endDate).format("YYYY.MM.DD"),
          icon: "calendar",
        });

        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "GET", url: "V2/Learn/courseDetail" },
          params: { id: c.id },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            //console.log('res', res);

            this.joinData.obj = c;
            this.joinData.mode = -22;
            this.joinData.cinfo = res.data.course.info;

            let discBoxes = res.data.course.boxes.filter(
              (x) => x.objectTypeId == 124
            );
            if (discBoxes.length > 0 && discBoxes[0].tasks.length > 0) {
              this.joinData.cdiscs = discBoxes[0].tasks;
            }

            this.joinData.modal = true;
          }
        });
      } else {
        this.joinData.mode = null;
        if (t != undefined && t.activeTab != 1 && c.option.directJoin == 1) {
          //console.log('stp 1');
          this.joinData.infos = [];
          this.joinData.infos.push({
            id: 1,
            title: "Эхлэх огноо",
            value: moment(c.startDate).format("YYYY.MM.DD"),
            icon: "calendar",
          });
          this.joinData.infos.push({
            id: 2,
            title: "Дуусах огноо",
            value: moment(c.endDate).format("YYYY.MM.DD"),
            icon: "calendar",
          });
          this.joinData.infos.push({
            id: 2,
            title: "Сургалтын цаг:",
            value: c.hour != null ? c.hour.toFixed(2) + " цаг" : "-",
            icon: "clock",
          });
          this.joinData.infos.push({
            id: 2,
            title: "Кредит оноо",
            value: c.creditPoint,
            icon: "clock",
          });
          // this.joinData.infos.push({
          //   id: 2,
          //   title: "Шалгалттай эсэх ",
          //   value: res.data.course.hasExam ? "Тийм" : "Үгүй",
          //   icon: "pen-tool"
          // });
          this.joinData.infos.push({
            id: 2,
            title: "Сертификаттай эсэх",
            value: c.certificateView == 1 ? "Тийм" : "Үгүй",
            icon: "award",
          });

          this.joinData.obj = c;
          this.joinData.modal = true;
        }

        if (t != undefined && t.activeTab == 0) {
          //console.log('stp 2');
          this.$router.push({
            name: "lmsAttend",
            params: { id: c.id, s1: 0, s2: 0 },
          });
        } else {
          //console.log('stp 3');
          this.$router.push({
            name: "lmsCourseView",
            params: { id: c.id, bid: 0, iid: 0, bot: 0 },
          });
        }
      }
    },
    directJoinToCourse(c) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TaskInUser/ShareTaskUser" },
        data: { userId: this.$store.state.user.userId, taskId: c.id },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.$router.push({
            name: "lmsCourseView",
            params: { id: c.id, bid: 0, iid: 0, bot: 0 },
          });
        }
      });
    },
  },
};
</script>
<style>
.drp-profile{
  position: relative;
  display: inline-block;
}
.drp-button {
  cursor: pointer;
}

.drp-menu {
  display: block;
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  z-index: 1000;
}

.drp-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.drp-menu li {
  padding: 10px;
  cursor: pointer;
}

.drp-menu li:hover {
  background-color: #f0f0f0;
}
</style>